// extracted by mini-css-extract-plugin
export default {"container":"floating_logo_container__QDgP7"};